import { Controller } from "@hotwired/stimulus"
import SignupFormHelper from "../helpers/signup_form_helper"

// Pure delegation into SignupFormHelper. Mounts on the invitation edit and sso views and on
// user_passwords/show, which render different subsets of the personal form's fields - sso has
// nothing beyond the terms link, user_passwords has no email and no confirmation toggle - so
// every handler no-ops when its field is absent.
export default class extends Controller {
  connect() {
    const $form = $(this.element).find(".personal-form").find("form");

    SignupFormHelper.enableFormValidation($form);
    SignupFormHelper.initTermsModal("#personal-terms", $form);
    SignupFormHelper.initTermsModal("#business-terms", $form);
  }

  showTermsModal(event) {
    SignupFormHelper.showTermsModal(event.params.selector);
  }

  togglePasswordConfirmationInput() {
    SignupFormHelper.togglePasswordConfirmationInput("personal");
  }
}
